import '@/style/app.scss';
import '@/style/pages/outlets/outlets.scss';
import { initSentry } from '@/js/services/sentry.js';
import { initGDPRConsent } from '@/js/partials/gdpr-consent.js';
import { initHeader } from '@/js/partials/header.js';
import { initNewsletterForms } from '@/js/partials/newsletter.js';
import { initTracking } from '@/js/services/tracking.js';
import { initModals } from '@/js/partials/modals.js';

window.addEventListener('DOMContentLoaded', () => {
	initSentry();
	initGDPRConsent();
	initHeader();
	initNewsletterForms();
	initTracking();
	initModals();
});
